import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import glamorous from "glamorous"
import style from "utils/style"

const Navigation = ({ currentUser }) => {
  return currentUser && currentUser.role === "staff" ? (
    <List>
      <ListItem>
        <StyledLink to="/camps_search">
          <LinkTitle>Search</LinkTitle>
          <LinkSubtitle>Camps</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/campers_search">
          <LinkTitle>Camper</LinkTitle>
          <LinkSubtitle>Search</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/info_requests/active">
          <LinkTitle>Info</LinkTitle>
          <LinkSubtitle>Requests</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/direct_emails">
          <LinkTitle>Direct</LinkTitle>
          <LinkSubtitle>Emails</LinkSubtitle>
        </StyledLink>
      </ListItem>
    </List>
  ) : currentUser && currentUser.role === "guardian" ? (
    <List>
      <ListItem>
        <StyledLink to="/camps_search">
          <LinkTitle>Search</LinkTitle>
          <LinkSubtitle>Camps</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/campers">
          <LinkTitle>Campers</LinkTitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/info_requests">
          <LinkTitle>Info</LinkTitle>
          <LinkSubtitle>Requests</LinkSubtitle>
        </StyledLink>
      </ListItem>
    </List>
  ) : (
    <List>
      <ListItem>
        <StyledLink to="/browse">
          <LinkTitle>Browse</LinkTitle>
          <LinkSubtitle>Camps</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/about/features/families">
          <LinkTitle>Features</LinkTitle>
          <LinkMiddle>for</LinkMiddle>
          <LinkSubtitle>Families</LinkSubtitle>
        </StyledLink>
      </ListItem>

      <ListItem>
        <StyledLink to="/about/features/camps">
          <LinkTitle>Features</LinkTitle>
          <LinkMiddle>for</LinkMiddle>
          <LinkSubtitle>Camps</LinkSubtitle>
        </StyledLink>
      </ListItem>
    </List>
  )
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(mapStateToProps)(Navigation)

const List = glamorous.ul({
  display: "flex",
  order: 0,
  flexGrow: 0,
  "@media(max-width: 750px)": {
    order: 2,
    flexGrow: 1,
    justifyContent: "space-between",
    borderBottom: `1px solid ${style.colors.gray}`,
  },
})

const ListItem = glamorous.li({
  display: "inline-block",
  flexGrow: 1,
  "@media(max-width: 750px)": {
    borderRight: `1px solid ${style.colors.gray}`,
  },
  "&:last-child": {
    border: "none",
  },
})

const StyledLink = glamorous(Link)({
  color: style.colors.brown,
  backgroundColor: style.colors.veryLightGray,
  textDecoration: "none",
  padding: 15,
  display: "flex",
  fontSize: "1em",
  transition: "all 0.3s",
  "@media(max-width: 750px)": {
    alignItems: "center",
    flexDirection: "column",
    padding: "15px 9px 15px 9px",
  },
  "&:hover": {
    backgroundColor: style.colors.lightGray,
  },
  "@media(min-width: 751px)": {
    padding: 10,
    fontSize: "0.9em",
  },
  "@media(min-width: 830px)": {
    padding: 15,
    fontSize: "1em",
  },
})

const LinkTitle = glamorous.span({
  display: "inline-block",
  paddingRight: 5,
  "@media(max-width: 750px)": {
    color: style.colors.darkBrown,
    paddingRight: 0,
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: 2,
    fontSize: "0.65em",
  },
})

const LinkMiddle = glamorous.span({
  display: "inline-block",
  paddingRight: 5,
  "@media(max-width: 750px)": {
    display: "none",
  },
})

const LinkSubtitle = glamorous.span({
  display: "inline-block",
  fontSize: "1em",
  "@media(max-width: 750px)": {
    paddingTop: 4,
    fontSize: "1.15em",
  },
})



// WEBPACK FOOTER //
// ./src/containers/Header/Navigation.js